import React, { useEffect } from "react";
import "./ResumeCard.css";
import AOS from "aos";
import "aos/dist/aos.css";

const ResumeCard = ({ details }) => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 200,
      easing: "ease-in-cubic",
      delay: 50,
    });
  }, []);

  return (
    <div className="resume-card" data-aos="fade-left">
      <h4>{details.title}</h4>
      <h5>{details.company}</h5>
      <div className="work-duration">
        <p>{details.date}</p>
      </div>
      <ul>
        {details.responsibilities.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

export default ResumeCard;
